// extracted by mini-css-extract-plugin
module.exports = {"desc":"confirmCampaignModal_desc__1GyAA","actions":"confirmCampaignModal_actions___CMyd"};